import {DateTime} from "luxon";
import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {appState} from "../../app.state";
import {TimelineJumpToDateCommand} from "../timeline-jump-to-date.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(TimelineJumpToDateCommand)
@singleton()
export class TimelineJumpToDateCommandHandler implements ICommandHandler<DateTime> {
    
    public async handle(command: ICommand<DateTime>): Promise<void> {
        // Nur den dateCursor setzen - Timeline-Updates passieren über Subscription
        appState.dateCursorDate = command.payload;
    }
}